export default function appViewerNotificationIsOpen(state) {
  return state.appViewerNotificationIsOpen;
}
